module.exports = __webpack_public_path__ + "img/logo-mobile.85938ca9.svg";